import { useState, useCallback } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../config/firebase";

export default function usePayments() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const recordPayment = useCallback(async ({ type, id, amount, method = "cash" }) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await addDoc(collection(db, "payments"), {
        [`${type}Id`]: id,
        amount: Number(amount),
        type,
        method,
        createdAt: serverTimestamp()
      });

      console.log("Paiement enregistré ✅");
      setSuccess(true);
      return true;
    } catch (err) {
      console.error("Erreur en enregistrant le paiement:", err);
      setError(err);
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return { recordPayment, loading, error, success };
}
